import React, { useState } from "react";

export default function PageTitle({ title }) {
  return (
    <div className="top-header-info">
      <div className="row">
        <div className="col-md-12">
          <h2>{title}</h2>
          <hr />
        </div>
      </div>
    </div>
  );
}
